import { FC } from 'react';
import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';

import styles from './StepHeader.module.scss';

type StepHeaderProps = {
  title: string;
  desc?: string;
  className?: string;
}

export const StepHeader: FC<StepHeaderProps> = ({
  title,
  desc,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <header className={ classNames(styles.StepHeader, className) }>
      <h3 className={ styles.StepHeader__Title }>{ t(title) }</h3>
      { desc && <h4 className={ styles.StepHeader__Desc }>{ t(desc) }</h4> }
    </header>
  );
};

export default StepHeader;
